var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:"show-article",attrs:{"id":"show-article"}},[_c('Menu'),_c('article',{staticClass:"show-article markdown-content",domProps:{"innerHTML":_vm._s(_vm.renderedArticle)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }